// Типы уведомлений (согласно API)
export const NotificationType = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

// Категории уведомлений (согласно API)
export const NotificationCategory = {
    SYSTEM: 'system',
    BONUS: 'bonus',
    PROFILE: 'profile',
    PAYMENT: 'payment',
    NETWORKING: 'networking',
    DPS: 'dps',
    FLOWERS: 'flowers',
    CONTEST: 'contest',
} as const;

export type NotificationCategory = typeof NotificationCategory[keyof typeof NotificationCategory];

// Каналы доставки
export const DeliveryChannel = {
    IN_APP: 'in-app',
    TELEGRAM: 'telegram',
    PUSH: 'push',
    EMAIL: 'email',
} as const;

export type DeliveryChannel = typeof DeliveryChannel[keyof typeof DeliveryChannel];

// Основная модель уведомления (согласно API)
export interface Notification {
    id: number;
    user_id: number;
    type: NotificationType;
    category: NotificationCategory;
    title: string;
    message: string;
    metadata?: Record<string, any>;
    is_read: boolean;
    priority: number; // 1-5 (5 = высший)
    delivery_channels: DeliveryChannel[];
    action_url?: string;
    image_url?: string;
    created_at: number; // Unix timestamp
    read_at?: number; // Unix timestamp
    expires_at?: number; // Unix timestamp
}

// Запрос списка уведомлений
export interface NotificationsListRequest {
    limit?: number;
    offset?: number;
    is_read?: boolean;
    category?: NotificationCategory;
    type?: NotificationType;
}

// Ответ списка уведомлений (согласно API)
export interface NotificationsListResponse {
    success: true;
    data: Notification[];
    total: number;
    limit: number;
    offset: number;
    has_more: boolean;
}

// Счетчик непрочитанных (согласно API)
export interface UnreadCountResponse {
    success: true;
    count: number;
}

// Ответ на действие (согласно API)
export interface NotificationActionResponse {
    success: true;
    message: string;
}

// Структура ошибки (согласно API)
export interface NotificationErrorResponse {
    success: false;
    error: string;
}

// Состояние для Redux
export interface NotificationsState {
    notifications: Notification[];
    unreadCount: number;
    loading: boolean;
    error: string | null;
    hasMore: boolean;
    currentOffset: number;
    filters: {
        isRead?: boolean;
        category?: NotificationCategory;
        type?: NotificationType;
    };
}
